import { InvoiceMissionSending } from 'src/modules/dashboard/models/invoiceMissionSending';
import AxiosInstance from './axios/interceptor';
import { InvoiceMissionSendingSearchfilter } from '../models/invoiceMission/iInvoiceMissionSendingSearchfilter';
import { PagedResult } from '../models/pagedResult';

const controller = 'InvoiceMissionSending';

export const getAllInvoiceMissionSending = (searchFilter: InvoiceMissionSendingSearchfilter) => {
  return AxiosInstance.get<PagedResult<InvoiceMissionSending>>(`${controller}`, { params: searchFilter });
};
